"use strict";

exports.__esModule = true;
exports.updatePromo = exports.addPromo = void 0;

var addPromo = function addPromo(value) {
  return {
    type: 'ADD_PROMO',
    value: value
  };
};

exports.addPromo = addPromo;

var updatePromo = function updatePromo(locationId, bannerPosition, promotionId, promotionName) {
  return {
    type: 'UPDATE_PROMO',
    locationId: locationId,
    promotionId: promotionId,
    promotionName: promotionName,
    bannerPosition: bannerPosition
  };
};

exports.updatePromo = updatePromo;